// ============================================================
// ProtectedRoute.js
// Guards admin-only routes.
//
// Two checks:
//   1. The user is authenticated via MSAL.
//   2. The user's UPN appears in REACT_APP_ADMIN_UPN_ALLOWLIST
//      (a comma-separated list injected at build time from Key
//      Vault by the pipeline).
//
// If unauthenticated -> redirect to /. If authenticated but not
// on the allowlist -> render an "Access denied" page with a
// sign-out option (NOT a silent redirect; the user needs to know
// why they cannot enter, and they need an explicit way out).
// ============================================================

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { isUpnAllowed } from '../authConfig';
import AccessDenied from '../pages/AccessDenied';

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const upn = accounts[0]?.username;
  if (!isUpnAllowed(upn)) {
    return <AccessDenied upn={upn} />;
  }

  return children;
}
